export class CommissionUpdate
{
    storeid: string;
    billerid: string;
    rate: string;  
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/commissionupdatemodel.ts